import api from '../services/api';
import { clientAuthConfig } from './clientAuthConfig';
import { getStoredConversationId, setStoredConversationId } from './buyerChatSession';

/**
 * Portal → chat navigation: resume existing buyer conversation when known,
 * otherwise land on the chat homepage (new conversation).
 * @returns {{ path: string, isResume: boolean }}
 */
export async function resolveBuyerChatPath(slug) {
  if (!slug) return { path: '/chat', isResume: false };

  let id = getStoredConversationId(slug, 'buyer');
  if (!id) {
    try {
      const latest = await api.get(
        '/clients/me/conversations/latest',
        clientAuthConfig(slug)
      );
      id = latest.data?.conversation?.conversation_id || null;
      if (id) setStoredConversationId(slug, id, 'buyer');
    } catch {
      /* no linked conversation — start fresh on homepage */
    }
  }

  if (id) {
    return { path: `/chat/${slug}/conversation/${id}`, isResume: true };
  }
  return { path: `/chat/${slug}`, isResume: false };
}
